<template>
    <v-card color="transparent" flat>
        <v-layout wrap align-center>
            <v-flex xs3 md2 lg1 pa-3>
                <v-avatar size="65" class="ma-0" color="grey lighten-2">
                    <v-img v-if="institution.settings && institution.settings.avatar_image"
                           :src="institution.settings.avatar_image"/>
                    <v-icon v-else color="grey">fas fa-building</v-icon>
                </v-avatar>
            </v-flex>
            <v-flex xs9 md10 lg11 pa-3>
                <v-card-title primary-title>
                    <div class="headline institution-name" @click="onClickName(institution)">
                        {{ institution.name }}
                    </div>
                    <div v-if="specialties" class="text-truncate text-xs-left full-width">
                        <small >{{ specialties }}</small>
                    </div>
                    <small v-if="specialties">
                        UF: {{ planAmount }}
                    </small>
                </v-card-title>
                <v-card-actions class="py-0" v-if="ratings && stars">
                    <v-rating
                        readonly v-model="stars"
                        background-color="secondary"
                        color="accent" dense half-increments
                        empty-icon="$vuetify.icons.ratingFull"
                        hover size="18"
                    />
                    <span class="primary--text text--lighten-2 caption ml-2">
                       ({{ stars || 0 }} / {{ specialist.ratings_summary.count }})
                    </span>
                </v-card-actions>
            </v-flex>
        </v-layout>
    </v-card>
</template>
<script>
export default {
    props: ['institution', 'toProfile', 'ratings'],
    computed: {
        specialties(vm = this) {
            if (!vm.institution.specialties || vm.institution.specialties.length === 0) return null
            let specialties = vm.institution.specialties.map(sp => sp.description)
            return specialties.join(', ')
        },
        stars(vm = this) {
            if (!vm.institution || !vm.institution.ratings_summary || !vm.institution.ratings_summary.avg) return null
            return Math.round(vm.institution.ratings_summary.avg * 100) / 100
        },
        starsColor() {
            return this.stars < 3 ? 'accent lighten-2' : 'yellow accent-4'
        },
        planAmount(vm = this) {
            if (!vm.institution) return 'n/d'
            return vm.institution.plan ? vm.institution.plan.amount : '0 (Gratis)'
        }
    },
    methods: {
        onClickName(entity) {
            const vm = this
            vm.$emit('click-name', entity)
            if (typeof vm.toProfile != 'undefined')
                vm.$router.push({name: 'provider.profile', params: {id: vm.toProfile}})
        }
    },
}
</script>

<style scoped>

.institution-name {
    cursor: pointer;
}

.institution-name:hover {
    color: #3192ff;
}

.full-width {
    width: 100%;
}
</style>